var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 511.98,
    height: 511.961,
    viewBox: "0 0 511.98 511.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 255.98,
    cy: 255.98,
    r: 255.98,
    transform: "translate(0.02 0.01)",
    fill: "rgba(39,170,183,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M387.723,107.628H47.381C-21.36,204.115-15.358,337.26,65.82,427.315h321.9a26.359,26.359,0,0,0,26.329-26.329V133.956A26.357,26.357,0,0,0,387.723,107.628Z",
    fill: "#647892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M62.513,400.986V133.956a26.36,26.36,0,0,1,26.33-26.329H47.381c-68.741,96.487-62.738,229.632,18.44,319.687H88.843A26.358,26.358,0,0,1,62.513,400.986Z",
    fill: "#4d6682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M44.33,399.961H379.738A6.96,6.96,0,0,0,386.7,393V190.493H8.495A255.969,255.969,0,0,0,44.33,399.961Z",
    fill: "#fac149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M44.334,399.961H62.513V190.493H8.495A256.154,256.154,0,0,0,44.334,399.961Z",
    fill: "#f8a748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M379.739,134.98H30.388A254.315,254.315,0,0,0,7.414,194.752H386.7V141.94A6.959,6.959,0,0,0,379.739,134.98Z",
    fill: "#3b5271"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M30.389,134.98A254.337,254.337,0,0,0,7.414,194.752h55.1V134.98Z",
    fill: "#304760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M33.974,173.228a7.987,7.987,0,1,1,7.986-7.985A8,8,0,0,1,33.974,173.228Z",
    fill: "#fc5b6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M62.513,173.228a7.987,7.987,0,1,1,7.985-7.984A8.012,8.012,0,0,1,62.513,173.228Z",
    fill: "#fac149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M91.075,173.228a7.986,7.986,0,1,1,7.985-7.984A8,8,0,0,1,91.075,173.228Z",
    fill: "#2fcc63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M350.682,173.225H125.475a7.984,7.984,0,1,1,0-15.968H350.682a7.984,7.984,0,1,1,0,15.968Z",
    fill: "#647892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M441.644,436.751a9.489,9.489,0,0,0-9.468-9.511H65.754a256.975,256.975,0,0,0,71.023,55.307H396.056A45.694,45.694,0,0,0,441.644,436.751Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M99.685,427.24V442.8a12.1,12.1,0,0,0,12.04,12.1h161.2a12.1,12.1,0,0,0,12.04-12.1V427.24Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M159.739,442.8V427.241H99.685V442.8a12.1,12.1,0,0,0,12.04,12.1h60.054A12.1,12.1,0,0,1,159.739,442.8Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M428.987,251.966H149.014a12.811,12.811,0,0,1-12.774-12.775V177.616a12.812,12.812,0,0,1,12.774-12.775H428.988a12.812,12.812,0,0,1,12.775,12.775v61.575A12.814,12.814,0,0,1,428.987,251.966Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M428.987,366.444H149.014a12.811,12.811,0,0,1-12.774-12.775V292.094a12.812,12.812,0,0,1,12.774-12.775H428.988a12.812,12.812,0,0,1,12.775,12.775v61.575A12.814,12.814,0,0,1,428.987,366.444Z",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M188.684,239.191V177.616a12.812,12.812,0,0,1,12.775-12.775H149.015a12.811,12.811,0,0,0-12.774,12.775v61.575a12.812,12.812,0,0,0,12.774,12.775h52.444A12.812,12.812,0,0,1,188.684,239.191Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M188.684,353.669V292.093a12.812,12.812,0,0,1,12.775-12.775H149.015a12.811,12.811,0,0,0-12.774,12.775v61.576a12.812,12.812,0,0,0,12.774,12.775h52.444A12.813,12.813,0,0,1,188.684,353.669Z",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M202.527,309.038a7.986,7.986,0,0,0-11.291,0l-2.552,2.552-2.552-2.552a7.984,7.984,0,0,0-11.291,11.292l2.551,2.551-2.551,2.551a7.984,7.984,0,1,0,11.29,11.292l2.552-2.552,2.552,2.552a7.984,7.984,0,1,0,11.29-11.292l-2.551-2.551,2.551-2.551A7.983,7.983,0,0,0,202.527,309.038Z",
    fill: "#bab6b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M252.685,309.038a7.986,7.986,0,0,0-11.291,0l-2.552,2.552-2.552-2.552A7.984,7.984,0,1,0,225,320.33l2.551,2.551L225,325.432a7.984,7.984,0,1,0,11.29,11.292l2.552-2.552,2.552,2.552a7.984,7.984,0,0,0,11.29-11.292l-2.551-2.551,2.551-2.551A7.981,7.981,0,0,0,252.685,309.038Z",
    fill: "#bab6b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M302.844,309.038a7.986,7.986,0,0,0-11.291,0L289,311.59l-2.552-2.552a7.984,7.984,0,1,0-11.291,11.292l2.551,2.551-2.551,2.551a7.984,7.984,0,1,0,11.29,11.292L289,334.172l2.552,2.552a7.984,7.984,0,0,0,11.29-11.292l-2.551-2.551,2.551-2.551A7.982,7.982,0,0,0,302.844,309.038Z",
    fill: "#bab6b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M353,309.038a7.986,7.986,0,0,0-11.291,0l-2.552,2.552-2.552-2.552a7.984,7.984,0,1,0-11.291,11.292l2.551,2.551-2.551,2.551a7.984,7.984,0,1,0,11.29,11.292l2.552-2.552,2.552,2.552A7.984,7.984,0,0,0,353,325.432l-2.551-2.551L353,320.33A7.983,7.983,0,0,0,353,309.038Z",
    fill: "#bab6b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M400.61,322.882l2.551-2.551a7.984,7.984,0,1,0-11.291-11.292l-2.552,2.552-2.552-2.552a7.984,7.984,0,1,0-11.291,11.292l2.551,2.551-2.551,2.551a7.984,7.984,0,1,0,11.29,11.292l2.552-2.552,2.552,2.552a7.984,7.984,0,0,0,11.29-11.292Z",
    fill: "#bab6b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M401.386,216.388H176.615a7.984,7.984,0,0,1,0-15.968H401.386a7.984,7.984,0,1,1,0,15.968Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M176.615,200.419a7.984,7.984,0,0,0,0,15.968h12.069V200.419Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_299",
    "data-name": "Ellipse 299",
    cx: 97.928,
    cy: 97.928,
    r: 97.928,
    transform: "translate(316.125 26.184)",
    fill: "#fac149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M355.244,158.068A97.956,97.956,0,0,1,378.66,32.788a97.933,97.933,0,1,0,96.788,167.639A97.952,97.952,0,0,1,355.244,158.068Z",
    fill: "#f8a748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M443.391,115.318a7.984,7.984,0,0,1-7.984-7.984V85.809a21.356,21.356,0,1,0-42.712,0v21.524a7.984,7.984,0,0,1-15.968,0V85.809a37.324,37.324,0,1,1,74.648,0v21.524A7.984,7.984,0,0,1,443.391,115.318Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M422.053,49.357a37.3,37.3,0,0,0-45.325,36.452v21.524a7.984,7.984,0,0,0,15.968,0V85.809c0-.448.04-.888.067-1.33A37.383,37.383,0,0,1,422.053,49.357Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M451.765,185.3H376.339a7.952,7.952,0,0,1-7.952-7.952V112.219a7.952,7.952,0,0,1,7.952-7.952h75.427a7.952,7.952,0,0,1,7.952,7.952v65.125A7.953,7.953,0,0,1,451.765,185.3Z",
    fill: "#fc5b6f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M392.241,177.344V112.219a7.952,7.952,0,0,1,7.952-7.952H376.339a7.952,7.952,0,0,0-7.952,7.952v65.125a7.951,7.951,0,0,0,7.952,7.951h23.854A7.951,7.951,0,0,1,392.241,177.344Z",
    fill: "#f74352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M427.849,139.452a13.8,13.8,0,1,0-21.78,11.238v7.991a7.984,7.984,0,0,0,15.968,0V150.69A13.772,13.772,0,0,0,427.849,139.452Z",
    fill: "#f74352"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M416.254,139.451a13.769,13.769,0,0,1,5.8-11.227,13.786,13.786,0,1,0-15.983,22.466v7.991a7.984,7.984,0,0,0,15.968,0v-7.99l.016-.013A13.768,13.768,0,0,1,416.254,139.451Z",
    fill: "#e8364c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.a6386bf9ebe816713cd899aad753ed52.svg";
export { ForwardRef as ReactComponent };